import $ from 'jquery'

var browserDetect = {
  isIPad: false,
  isIE9: false,
  isIE10: false,
  isIE11: false,
  isIE: false,
  isEdge: false,
  isEdgeOrIE: false,
  isSafari: false
}
if (/iPad/i.test(navigator.userAgent)) {
  browserDetect.isIPad = true
}
if (/MSIE 9/i.test(navigator.userAgent)) {
  browserDetect.isIE9 = true
}
if (/MSIE 10/i.test(navigator.userAgent)) {
  browserDetect.isIE10 = true
}
if (/rv:11.0/i.test(navigator.userAgent)) {
  browserDetect.isIE11 = true
}
if (browserDetect.isIE9 || browserDetect.isIE10 || browserDetect.isIE11) {
  browserDetect.isIE = true
}
if (/Edge\/\d./i.test(navigator.userAgent)) {
  browserDetect.isEdge = true
}
if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase())) {
  browserDetect.isSafari = true
}
if (browserDetect.isEdge || browserDetect.isIE) {
  browserDetect.isEdgeOrIE = true
}
browserDetect.addGlobalClasses = function () {
  for (var prop in browserDetect) {
    if (browserDetect.hasOwnProperty(prop) && browserDetect[prop] === true) {
      $('html').addClass(prop)
    }
  }
}

export default browserDetect



// WEBPACK FOOTER //
// ./src/common/js/browserdetect/browserdetect.js